import React from 'react'

const SendIcon = props => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_3980_39111)'>
      <path
        d='M15.1121 2.95677C15.3912 3.35543 15.3826 3.8905 15.0921 4.42757L9.26449 15.1898C9.12252 15.452 8.94778 15.6557 8.75118 15.7934C8.46667 15.9926 8.13188 16.048 7.82422 15.9468C7.55785 15.8558 7.20117 15.6254 6.99246 14.9902L5.64343 10.9134C5.60737 10.7921 5.54547 10.6573 5.46806 10.5235L11.0001 6.6499C11.3004 6.43959 11.3741 6.02177 11.1638 5.72142C10.9535 5.42106 10.5357 5.34739 10.2353 5.5577L4.7033 9.43126C4.60388 9.31368 4.49791 9.20884 4.39686 9.1331L1.02726 6.47106C0.501806 6.0577 0.407263 5.64372 0.413778 5.36245C0.428994 4.81466 0.879511 4.37712 1.6168 4.26779L13.7237 2.47215C14.3277 2.38287 14.833 2.55812 15.1121 2.95677Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_3980_39111'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default SendIcon
